

export const status = {
  'A': 'Aguardando',
  'N': 'Negociando',
  'C': 'Cancelada',
  'F': 'Finalizada',
}

export const reacoes = {
  0: '😬 Indiferente',
  1: '🥰 Receptivo',
  2: '🤩 Demonstrou Interesse',
  3: '👀 Outros',
}
